import React from 'react';
import { Card } from '@/components/ui/card';
import { MusikkKategori } from '@/services/api';
import { SongCardHeader } from './SongCardHeader';
import { SongBasicFields } from './SongBasicFields';
import { SongMetadataFields } from './SongMetadataFields';
import { SongCategoriesInput } from './SongCategoriesInput';
import { SongNotesField } from './SongNotesField';

interface SongBasicInfoCardProps {
  tittel: string;
  artist: string;
  album: string;
  utgivelsesaar: number | '';
  bpm: number | '';
  takt: string;
  lengdeMinutter: number | '';
  lengdeSekunder: number | '';
  categories: string[];
  categoryInput: string;
  showKategoriDropdown: boolean;
  newKategoriWarning: string | null;
  filteredKategorier: MusikkKategori[];
  notater: string;
  publisert: boolean;
  onTittelChange: (value: string) => void;
  onArtistChange: (value: string) => void;
  onAlbumChange: (value: string) => void;
  onUtgivelsesaarChange: (value: number | '') => void;
  onBpmChange: (value: number | '') => void;
  onTaktChange: (value: string) => void;
  onLengdeMinutterChange: (value: number | '') => void;
  onLengdeSekunderChange: (value: number | '') => void;
  onCategoriesChange: (categories: string[]) => void;
  onCategoryInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCategoryInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onCategoryInputFocus: () => void;
  onCategoryInputBlur: () => void;
  onCategorySelect: (kategori: MusikkKategori) => void;
  onConfirmNewCategory: () => void;
  onRemoveCategory: (category: string) => void;
  onCancelNewCategory: () => void;
  onNotaterChange: (value: string) => void;
  onPublisertToggle: () => void;
}

export const SongBasicInfoCard: React.FC<SongBasicInfoCardProps> = ({
  tittel,
  artist,
  album,
  utgivelsesaar,
  bpm,
  takt,
  lengdeMinutter,
  lengdeSekunder,
  categories,
  categoryInput,
  showKategoriDropdown,
  newKategoriWarning,
  filteredKategorier,
  notater,
  publisert,
  onTittelChange,
  onArtistChange,
  onAlbumChange,
  onUtgivelsesaarChange,
  onBpmChange,
  onTaktChange,
  onLengdeMinutterChange,
  onLengdeSekunderChange,
  onCategoriesChange,
  onCategoryInputChange,
  onCategoryInputKeyDown,
  onCategoryInputFocus,
  onCategoryInputBlur,
  onCategorySelect,
  onConfirmNewCategory,
  onRemoveCategory,
  onCancelNewCategory,
  onNotaterChange,
  onPublisertToggle,
}) => {
  return (
    <Card className="shadow-sm hover:shadow-md transition-shadow overflow-hidden">
      <div className="h-1 bg-gradient-to-r from-primary to-blue-400" />
      <div className="p-6">
        <SongCardHeader
          publisert={publisert}
          onPublisertToggle={onPublisertToggle}
        />

        <div className="space-y-4">
          <SongBasicFields
            tittel={tittel}
            artist={artist}
            album={album}
            onTittelChange={onTittelChange}
            onArtistChange={onArtistChange}
            onAlbumChange={onAlbumChange}
          />

          <SongMetadataFields
            utgivelsesaar={utgivelsesaar}
            bpm={bpm}
            takt={takt}
            lengdeMinutter={lengdeMinutter}
            lengdeSekunder={lengdeSekunder}
            onUtgivelsesaarChange={onUtgivelsesaarChange}
            onBpmChange={onBpmChange}
            onTaktChange={onTaktChange}
            onLengdeMinutterChange={onLengdeMinutterChange}
            onLengdeSekunderChange={onLengdeSekunderChange}
          />

          <SongCategoriesInput
            categories={categories}
            categoryInput={categoryInput}
            showKategoriDropdown={showKategoriDropdown}
            newKategoriWarning={newKategoriWarning}
            filteredKategorier={filteredKategorier}
            onCategoryInputChange={onCategoryInputChange}
            onCategoryInputKeyDown={onCategoryInputKeyDown}
            onCategoryInputFocus={onCategoryInputFocus}
            onCategoryInputBlur={onCategoryInputBlur}
            onCategorySelect={onCategorySelect}
            onConfirmNewCategory={onConfirmNewCategory}
            onRemoveCategory={onRemoveCategory}
            onCancelNewCategory={onCancelNewCategory}
          />

          <SongNotesField
            notater={notater}
            onNotaterChange={onNotaterChange}
          />
        </div>
      </div>
    </Card>
  );
};

